export const usePermission = () => {
  var userData = JSON.parse(localStorage.getItem("userData")) || {};
  const permissions = userData.roles && userData.roles[0].permissions;

  const hasPermission = (permissionName) => {
    return (
      permissions?.filter((e) => e.acl.includes(permissionName)).length > 0
    );
  };

  return { hasPermission };
};
